/**
 * Y-Axis Component
 *
 * Renders the Y-axis with value labels and grid lines.
 */

import { CHART_CONFIG, CHART_COLORS } from "../constants";
import { getChartDimensions, valueToY, formatCurrency } from "../utils";

interface YAxisProps {
  min: number;
  max: number;
}

/**
 * Y-axis with value labels
 */
export function YAxis({ min, max }: YAxisProps) {
  const { innerHeight } = getChartDimensions();
  const tickCount = 5;
  const ticks = Array.from({ length: tickCount }, (_, i) => {
    const value = min + ((max - min) * i) / (tickCount - 1);
    return { value, y: valueToY(value, min, max) };
  }).reverse();

  return (
    <g className="y-axis">
      {/* Axis line */}
      <line
        x1={CHART_CONFIG.paddingLeft}
        y1={CHART_CONFIG.paddingTop}
        x2={CHART_CONFIG.paddingLeft}
        y2={CHART_CONFIG.paddingTop + innerHeight}
        stroke="currentColor"
        strokeOpacity={0.2}
        strokeWidth={1}
      />
      {/* Tick labels and grid lines */}
      {ticks.map(({ value, y }, index) => (
        <g key={index}>
          <line
            x1={CHART_CONFIG.paddingLeft}
            y1={y}
            x2={CHART_CONFIG.width - CHART_CONFIG.paddingRight}
            y2={y}
            stroke={CHART_COLORS.grid.stroke}
            strokeOpacity={CHART_COLORS.grid.opacity}
            strokeWidth={1}
          />
          <text
            x={CHART_CONFIG.paddingLeft - 8}
            y={y}
            textAnchor="end"
            dominantBaseline="middle"
            className="fill-muted-foreground text-[9px]"
          >
            {formatCurrency(value)}
          </text>
        </g>
      ))}
    </g>
  );
}
